import { render } from "./ModalForm.vue?vue&type=template&id=b459b0f2"
import script from "./ModalForm.vue?vue&type=script&lang=js"
export * from "./ModalForm.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__